import { useTranslation } from 'react-i18next';
import { getMainSetting } from '../functions/getMainSetting';
import { MainSettingsEnum } from '../models/enums/mainSettings.enum';
import { useGlobals } from '../contexts/appContext';

const useDistrictPickerHeader = () => {
  const { currentUser } = useGlobals();
  const { t } = useTranslation();

  const districtName = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.CountyLabel, t('member:tableHeaders.district'));
  const associationName = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.LocalLabel, t('member:tableHeaders.association'));
  const userHasDistrict = getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.AssSelectorType, 'test') !== 'local';

  const pickerHeader = !userHasDistrict ? associationName : t('common:form.genericPickerHeader', { districtName, associationName });

  return { pickerHeader, userHasDistrict, districtName, associationName };
};

export default useDistrictPickerHeader;
